import { file, mimeType, pipe } from "valibot";

export const BACKGROUND_MIME_TYPES = ["image/jpeg", "image/png", "image/webp"] as const;

export const PHOTO_MIME_TYPES = ["image/jpeg", "image/png", "image/webp"] as const;

export const backgroundFileSchema = pipe(
	file("Please select a background image."),
	mimeType(BACKGROUND_MIME_TYPES, "Please select a JPEG, PNG, or WebP file.")
);

export const photoFileSchema = pipe(
	file("Please select an image."),
	mimeType(PHOTO_MIME_TYPES, "Please select a JPEG, PNG, or WebP file.")
);
